// src/components/ReferralCreditStatus.jsx
import { useEffect, useState } from "react";
import {
  Box,
  Text,
  VStack,
  Badge,
  Spinner,
} from "@chakra-ui/react";
import { supabase } from "../utils/supabaseClient";
import useBusinessGuard from "../hooks/useBusinessGuard";

/**
 * ReferralCreditStatus
 * Shows referral credits for the current business.
 * Uses UUID identifiers (referrer_uuid).
 */
export default function ReferralCreditStatus() {
  const { businessIdUuid, loading: authLoading } = useBusinessGuard();
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading || !businessIdUuid) return;

    const fetchCredits = async () => {
      try {
        const { data, error } = await supabase
          .from("referrals")
          .select("referred_email, credited")
          .eq("referrer_uuid", businessIdUuid);

        if (error) {
          console.error("[ReferralCreditStatus] Referral credits error:", error);
          setReferrals([]);
        } else {
          setReferrals(data || []);
        }
      } catch (err) {
        console.error("[ReferralCreditStatus] Exception:", err);
        setReferrals([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCredits();
  }, [authLoading, businessIdUuid]);

  if (loading) return <Spinner size="sm" />;

  return (
    <Box>
      <Text fontSize="md" fontWeight="bold" mb={2}>
        🎯 Your Referral Credits
      </Text>

      <VStack align="start" spacing={2}>
        {referrals.map((r, i) => (
          <Box key={i}>
            <Text fontSize="sm">
              {r.referred_email} —{" "}
              {r.credited ? (
                <Badge colorScheme="green">Credited</Badge>
              ) : (
                <Badge colorScheme="red">Pending</Badge>
              )}
            </Text>
          </Box>
        ))}

        {referrals.length === 0 && (
          <Text fontSize="sm" color="gray.500">
            No referrals yet.
          </Text>
        )}
      </VStack>
    </Box>
  );
}
